module.exports = __webpack_public_path__ + "static/img/vr-btn-comment.a9c203f1.png";